import React from 'react';
import Login, { Render } from 'react-login-page';
import Logo from 'react-login-page/logo-rect';
import { signInWithPopup,GoogleAuthProvider } from "firebase/auth";

import {signinWithGoogle} from '../../services/firebase/index';
import {useAuth} from '../../context/authContext';
import {Profile} from '../profile/index';
import {CustomerServiceContext } from '../../context/customer';
import { Customer } from '../../providers/customer/types';
import { useAsyncFn } from '../../hooks/useAsync';
import { CustomerAtom } from '../../atoms/customerAtom';
import { useRecoilState } from 'recoil';
import { useTheme } from '../../context/ThemeContext';

export const LoginPage = () => {

const customerService = React.useContext(CustomerServiceContext);
  
  const {user,userLogin,loading } = useAuth();
  const [errorMessage, setErrorMessage] = React.useState('');
  const [customer, setCustomer] = useRecoilState(CustomerAtom);
  const { isDarkMode } = useTheme();
  console.log(user)
  const [googleSignInState, googleSignIn] = useAsyncFn(async() => {
      return   signinWithGoogle();
    });
  
    const [getCustomerState, getCustomer] = useAsyncFn(async(email: string) => {
      return await customerService.getCustomerByEmail(email);
    });

    const [createCustomerState, createCustomer] = useAsyncFn(async(c1: Customer) => {
        return await customerService.createCustomer(c1);
      });
    


  const handleGoogleLogin = async() => {
    if (!userLogin) {
      const logindata = await googleSignIn();
      
      const customer = await getCustomer(logindata?.user?.email as string);
      console.log(customer);

    } else {
      console.log('already signed in');
    }

   
  }
  if (getCustomerState.error) {
    console.log(getCustomerState.error);
    console.log(getCustomerState.status);
    console.log('googleSignInState.error', googleSignInState.error)
    if (!googleSignInState.error) { 
      const c1: Customer = {
                email: user.email as string,
                username: user.displayName as string,
                thirdPartyType: user.providerData[0].providerId as string,
                thirdPartyId: user.providerData[0].uid as string,
                password: 'temp',
                thirdPartyToken: user.uid as string,
                profile_image: user.photoURL as string,
              };
              createCustomer(c1);
      console.log('google sign in error');
      // getCustomerState.error = null;

    }
  }

  if (userLogin && !loading && user && customer) {
    window.location.href = '#/profile';
  }
  
  

    return (
        <>
          
          <div className={`flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
              
              <h2 className={`mt-10 text-center text-2xl/9 font-bold tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Sign in to your account
              </h2>
            </div>
    
            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
              <form action="#" method="POST" className="space-y-6">
                <div>
                  <label htmlFor="email" className={`block text-sm/6 font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    Email address
                  </label>
                  <div className="mt-2">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      autoComplete="email"
                      className={`block w-full rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-accent-primary sm:text-sm/6 ${
                        isDarkMode 
                          ? 'bg-gray-800 text-white outline-gray-700' 
                          : 'bg-white text-gray-900 outline-gray-300'
                      }`}
                    />
                  </div>
                </div>
    
                <div>
                  <div className="flex items-center justify-between">
                    <label htmlFor="password" className={`block text-sm/6 font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Password
                    </label>
                    <div className="text-sm">
                      <a href="#" className="font-semibold text-accent-primary hover:text-accent-primary-dark">
                        Forgot password?
                      </a>
                    </div>
                  </div>
                  <div className="mt-2">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      required
                      autoComplete="current-password"
                      className={`block w-full rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-accent-primary sm:text-sm/6 ${
                        isDarkMode 
                          ? 'bg-gray-800 text-white outline-gray-700' 
                          : 'bg-white text-gray-900 outline-gray-300'
                      }`}
                    />
                  </div>
                </div>
    
                <div>
                  <button
                    type="submit"
                    className="flex w-full justify-center rounded-md bg-accent-primary px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-accent-primary-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-primary"
                  >
                    Sign in
                  </button>
                </div>
              </form>

              <div className="relative mt-6">
                <div className="absolute inset-0 flex items-center">
                  <div className={`w-full border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-300'}`} />
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className={`px-2 ${isDarkMode ? 'bg-gray-900 text-gray-400' : 'bg-white text-gray-500'}`}>or</span>
                </div>
                </div>

                <div className="mt-6">
                  <button
                  onClick={handleGoogleLogin}
                  type="button"
                  className="flex w-full justify-center rounded-md bg-gray-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                  >
                  Log in with Google
                  </button>
                </div>
                

              
    
              <p className={`mt-10 text-center text-sm/6 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Not a member?{' '}
                <a href="#/signup" className="font-semibold text-accent-primary hover:text-accent-primary-dark">
                  Signup
                </a>
              </p>
            </div>
          
          </div>
        </>
      )
    



};